<template>
	<v-container fluid :loading="loading" class="fixed_header">
		<header class="d-flex title">
			<h1 class="text-h5 w100">회원 정보</h1>
			<v-tabs v-model="tab" right @change="onChangeTab" height="30">
				<v-tab>기본정보(리뷰/이벤트)</v-tab>
				<v-tab>출석체크</v-tab>
				<v-tab>Q&A</v-tab>
				<v-tab>FCM 토픽</v-tab>
			</v-tabs>
		</header>

		<v-tabs-items v-model="tab">
			<v-tab-item>
				<GeneralTab ref="general_tab" />
			</v-tab-item>
			<v-tab-item>
				<StampTab ref="stamp_tab" />
			</v-tab-item>
			<v-tab-item>
				<QnaTab ref="qna_tab" />
			</v-tab-item>
			<v-tab-item>
				<FcmTab ref="fcm_tab" />
			</v-tab-item>
		</v-tabs-items>
	</v-container>
</template>

<script>
	import GeneralTab from './GeneralTab.vue';
	import StampTab from './StampTab';
	import QnaTab from './QnaTab.vue';
	import FcmTab from './FcmTab.vue';

	export default {
		name: 'RegisterInfo',
		components: {
			GeneralTab,
			StampTab,
			QnaTab,
			FcmTab,
		},
		data() {
			return {
				loading: false,
				tab: parseInt(this.$route.query.tab || 0),
			};
		},
		methods: {
			onChangeTab() {
				const tabActions = {
					0: () => this.$refs.general_tab?.initData(),
					1: () => this.$refs.stamp_tab?.load(),
					2: () => this.$refs.qna_tab?.load(),
					3: () => this.$refs.fcm_tab?.load(),
				};

				if (tabActions[this.tab]) {
					tabActions[this.tab]();
				}
			},
		},
	};
</script>

<style lang="scss" scoped></style>
